import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const OperationalHealthDashboardStyled = styled.div`
  padding: 20px;
  overflow-x: auto;
  width: 100%;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
`;

export const HeroMetricContainer = styled.div`
  display: flex;
  gap: 20px;
  &:last-child div::after {
    content: '';
    display: block;
    position: absolute;
    right: -20px;
    width: 20px;
    height: 1px;
  }
`;

export const GraphContainer = styled.div`
  width: 100%;
  padding-left: 0;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  min-width: 940px;
  display: flex;
  align-items: center;
`;

export const PageTitle = styled.h1`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH3)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin-top: 5px;
  min-width: 980px;
  margin-bottom: 34px;
`;

export const ClickableTitle = styled.span`
  color: ${(props) => props.theme.atlas.semantic.color.action.link.default};
  text-decoration: underline;
  cursor: pointer;
  @media (hover: hover) {
    &:hover {
      color: ${(props) => props.theme.atlas.semantic.color.action.link.active};
    }
  }
`;

export const DividerContainer = styled.div`
  margin: 25px 0 20px 0;
  min-width: 980px;
`;

export const PanelContainer = styled(GraphContainer)`
  justify-content: center;
  height: 100%;
  padding-top: 0px;
`;

export const GraphTableContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
